import { requiredUuidString } from '../zod-helpers/index.js';
import { createTransferOrderItemSchema } from './create-input.js';
export const updateTransferOrderLineInputSchema = createTransferOrderItemSchema
    .omit({ partId: true })
    .extend({
    transferOrderId: requiredUuidString('Transfer order id is required.', 'Invalid transfer order id.'),
    id: requiredUuidString('Line id is required.', 'Invalid line id.'),
});
//# sourceMappingURL=update-line-input.js.map